import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'InviteRelationship',
    column_type: 'id',
  },
  created_at: {
    model_name: 'InviteRelationship',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'InviteRelationship',
    column_type: 'datetime',
  },
  name: {
    model_name: 'InviteRelationship',
    column_type: 'string',
  },
  phone: {
    model_name: 'InviteRelationship',
    column_type: 'string',
  },
  parent: {
    model_name: 'InviteRelationship',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'parent',
      model_name: 'InviteRelationship',
      foreign_key: 'parent_id',
    },
  },
  parent_id: {
    model_name: 'InviteRelationship',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'parent',
      model_name: 'InviteRelationship',
      foreign_key: 'parent_id',
    },
  },
  user: {
    model_name: 'InviteRelationship',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'user',
      model_name: 'User',
      foreign_key: 'user_id',
    },
  },
  user_id: {
    model_name: 'InviteRelationship',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'user',
      model_name: 'User',
      foreign_key: 'user_id',
    },
  },
  remark: {
    model_name: 'InviteRelationship',
    column_type: 'string',
  },
  children: {
    model_name: 'InviteRelationship',
    column_type: 'has_many',
    extra: {
      association_name: 'children',
      model_name: 'InviteRelationship',
      foreign_key: 'parent_id',
    },
  },
  child_ids: {
    model_name: 'InviteRelationship',
    column_type: 'has_many',
    extra: {
      association_name: 'children',
      model_name: 'InviteRelationship',
      foreign_key: 'parent_id',
    },
  },
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
